<template>
  <q-layout id="login">
      <q-header style="border:none;" class="" >
        <q-toolbar  color="transparent"   text-color="white" style="border:none;background-color:transparent" class="no-shadow" >
        <q-toolbar-title></q-toolbar-title>
        <img :src='companyLogo' style="image-rendering: auto; max-width: 200px; max-height: 55px;" class="q-ma-md"/>
      </q-toolbar>
       </q-header>
    <q-page-container class="no-shadow" borderless>
      <ResetPage />
    </q-page-container>
  <q-footer class="AppFooter transparent" >
    <q-toolbar>
      <FooterComponent/>
    </q-toolbar>
  </q-footer>
  </q-layout>
</template>

<script>
import ResetPage from '@/components/ResetPage.vue'
import FooterComponent from '@/components/FooterComponent.vue'
export default {
name: 'login',
components: {
  ResetPage,
  FooterComponent
},
data() {
  return {
    companyLogo: this.$store.getters.getCompanyLogo('white')
  }
}
}
</script>



<!-- TODO script to call -->
